import { useCallback } from 'react';
import { useParams } from 'react-router';

import { useRenewSubscriptionMutation } from 'store/api/version-api.slice';
import { formatRenewalDescription, getMemberCustomerIdOrEmail, getMemberPlanTypeName } from 'utils';
import { ERROR, SUCCESS } from 'constants/index';
import { prepareBankAmount } from 'adapters';

import useDispatchMessage from './useDispatchMessage';

const useProcessStripePayment = ({ setPaymentStatus, onComplete }) => {
	const params = useParams();

	const [renewSubscription] = useRenewSubscriptionMutation();

	const dispatchMessage = useDispatchMessage();

	const handler = useCallback(
		async data => {
			try {
				const result = await renewSubscription({
					portalId: params.portal_id,
					contactId: params.contact_id,
					data: {
						payment_intent_id: data.id,
						payment_method_id: data.payment_method,
						return_url: data.return_url,
						...getMemberCustomerIdOrEmail({
							customerId: data.st_customer_id,
							email: data?.email
						}),
						member_type_id: data.plan_type,
						description: formatRenewalDescription({
							email: data?.email,
							memberTypeName: getMemberPlanTypeName({ plans: data.plans, planTypeId: data.plan_type })
						}),
						save_card_information: data.save_card_information
					}
				});

				if (result.data.status === 'succeeded') {
					const message = `Your payment of ${prepareBankAmount({ amount: result.data.amount })} ${result.data.currency.toUpperCase()} has been processed successfully`;

					dispatchMessage({
						message
					});
					setPaymentStatus(SUCCESS);
				} else {
					dispatchMessage({
						message: 'Payment Failed! Please, try again later',
						variant: 'error'
					});
					setPaymentStatus(ERROR);
				}
			} catch (e) {
				const message = e?.detail.includes('INVALID_CARD_DATA')
					? 'Payment Failed! Something wrong with your card data. Please, try again'
					: 'Payment Failed! Please, try again later';
				dispatchMessage({
					message,
					variant: 'error'
				});
				setPaymentStatus(ERROR);
			} finally {
				onComplete?.();
			}
		},
		[renewSubscription, onComplete, dispatchMessage, setPaymentStatus, params]
	);

	return handler;
};

export default useProcessStripePayment;
